import { __awaiter, __generator } from "tslib";
import { defineComponent, ref } from 'vue';
import { createPlatform } from '@/api/admin/platforms';
import { notify } from '@/utils/toast';
import { toast } from 'vue3-toastify';
import router from '@/routes';
export default defineComponent({
    setup: function () {
        var _this = this;
        var platform = ref({
            name: '',
        });
        var create = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, createPlatform(platform.value)];
                    case 1:
                        _a.sent();
                        router.push('/admin/platforms');
                        notify('Plataforma creada con éxito', 'success', toast.POSITION.BOTTOM_CENTER);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        if (error_1.response.status === 401) {
                            notify('No tiene permisos para esta solicitud', 'danger', toast.POSITION.BOTTOM_CENTER);
                        }
                        else if (error_1.response.status === 404) {
                            notify('No existe la solicitud', 'danger', toast.POSITION.BOTTOM_CENTER);
                        }
                        else {
                            console.error(error_1.message);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        return {
            platform: platform,
            create: create,
        };
    },
});
